const selectors = {
    el: '.js-accordion:not(.is-initialized)',
    item: '.js-accordion-item'
}

const init = () => {
    const els = document.querySelectorAll(selectors.el);
    els.forEach(el => {
        el.classList.add('is-initialized');
        const items = el.querySelectorAll(selectors.item);

        const observer = new MutationObserver(mutationList => {
            for (const mutation of mutationList) {
                const isOpen = mutation.target.matches('.is-open');
    
                if (!isOpen) return;
                items.forEach(item => {
                    if (item === mutation.target) return;
                    item.expandable.toggleContent(false);
                });
            }
        });

        items.forEach(item => {
            observer.observe(item, { attributes: true });
        });
    });
};

const module = () => {
    init();
    document.addEventListener('domUpdated', init);
};

export default module;